if (typeof jQuery !== "undefined" && typeof (jQuery as any).parseJSON === "undefined") {
    (jQuery as any).parseJSON = JSON.parse;
}
interface JQueryValidatorDefaults {
    highlight: (element: HTMLElement) => void;
    unhighlight: (element: HTMLElement) => void;
    parseJSON?: (json: string) => any;
}

(() => { 
    if (typeof $ === 'undefined') { 
        return;
    }
    if (typeof $.validator === 'undefined') {
         return;
    } 
    const inputErrorClass = 'is-invalid';
    const messageErrorClass = 'invalid-feedback';
    const inputValidClass = 'is-valid';
    const loginValidationFieldClass = 'login-validation-field';

    const defaultOptions: JQueryValidatorDefaults = {
        highlight: (element: HTMLElement) => {
            const $element = $(element);
            if ($element.hasClass('form-control')) {
                $element.removeClass(inputValidClass);
                $element.addClass(inputErrorClass);
                $element.addClass(loginValidationFieldClass);
            }
            const $formGroup = $element.closest('.form-group');
            $formGroup.find('span[data-valmsg-for]').addClass(messageErrorClass);
            const $formRow = $element.closest('.form-row');
            $formRow.find('span[data-valmsg-for]').addClass(messageErrorClass);
        },
        unhighlight: (element: HTMLElement) => {
            const $element = $(element);
            if ($element.hasClass('form-control')) {
                $element.removeClass(inputErrorClass);
                $element.removeClass(loginValidationFieldClass);
                $element.addClass(inputValidClass);
            }
            const $formGroup = $element.closest('.form-group');
            $formGroup.find('span[data-valmsg-for]').removeClass(messageErrorClass);
            const $formRow = $element.closest('.form-row');
            $formRow.find('span[data-valmsg-for]').removeClass(messageErrorClass);
        },
        parseJSON: JSON.parse
    };
    ($.validator as any).setDefaults(defaultOptions);
})();
